<template>
  <nav
    v-if="translations && translations.navbar && translations.buttons"
    class="viewcontentnav"
  >
    <div id="allTheNav">
      <nav id="navigator" class="navbar" :class="{ navbaropen: opened }">
        <span class="open-slide">
          <button type="button" class="burger" @click="show()">
            <div>
              <div class="bar" :class="{ topopen: opened }"></div>
              <div class="bar" :class="{ midopen: opened }"></div>
              <div class="bar" :class="{ botopen: opened }"></div>
            </div>
          </button>
        </span>
        <ul class="navbar-nav">
          <li>
            <button class="navbutton" @click="goFront" type="button">
              <img class="logo" :src="files + '/logo.png'" />
              FestApp
            </button>
          </li>

          <li v-if="logged">
            <router-link to="/account"
              ><img :src="require('@/assets/icon/user.svg')"
            /></router-link>
          </li>
          <li v-if="editor && logged">
            <router-link to="/activities">{{
              translations.navbar.nav_activity
            }}</router-link>
          </li>
          <li v-if="usertype == 2 && logged">
            <router-link to="/equipments">{{
              translations.navbar.nav_equipment
            }}</router-link>
          </li>
          <li v-if="usertype == 2 && logged">
            <router-link to="/programs">{{
              translations.navbar.nav_programs
            }}</router-link>
          </li>
          <li v-if="logged">
            <router-link to="/events" :class="defineClass('event')">{{
              translations.navbar.nav_event
            }}</router-link>
          </li>
          <li v-if="!logged">
            <router-link to="/login">
              {{ translations.navbar.nav_login }}
            </router-link>
          </li>
          <li v-if="!logged">
            <router-link to="/register">
              {{ translations.buttons.btn_regist }}
            </router-link>
          </li>
          <li>
            <div class="logout" v-if="logged">
              <button class="btn btn-danger" @click="logout()">
                {{ translations.buttons.btn_logout }}
              </button>
            </div>
          </li>
        </ul>
      </nav>
      <div id="side-menu" class="side-nav" :class="{ sidenavopen: opened }">
        <router-link
          to="/events"
          class="a_color"
          :class="defineClass('event')"
          v-if="logged"
          >{{ translations.navbar.nav_event }}</router-link
        >
        <router-link to="/activities" class="a_color" v-if="editor && logged">{{
          translations.navbar.nav_activity
        }}</router-link>

        <router-link
          to="/programs"
          class="a_color"
          v-if="usertype == 2 && logged"
          >{{ translations.navbar.nav_programs }}</router-link
        >
        <router-link
          to="/equipments"
          class="a_color"
          v-if="usertype == 2 && logged"
          >{{ translations.navbar.nav_equipment }}</router-link
        >
        <router-link to="/account" class="a_color" v-if="logged"
          ><img :src="require('@/assets/icon/user.svg')"
        /></router-link>
        <router-link to="/contact" class="a_color" v-if="logged">{{
          translations.navbar.nav_contact
        }}</router-link>
        <router-link class="a_color" to="/login" v-if="!logged">
          {{ translations.navbar.nav_login }}
        </router-link>
        <router-link to="/register" class="a_color" v-if="!logged">
          {{ translations.buttons.btn_regist }}
        </router-link>
        <Flags type="side" />

        <div class="separator" v-if="logged"></div>

        <button
          class="btn btn-success"
          v-if="logged && usertype == 2"
          @click="generateMemory()"
        >
          {{ translations.buttons.btn_memory }}
        </button>
        <button class="btn btn-danger" v-if="logged" @click="logout()">
          {{ translations.navbar.nav_logout }}
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Flags from '@/components/Flags.vue'
  export default {
    name: 'Navbar',
    components: {
      Flags,
    },
    data() {
      return {
        opened: false,
      }
    },
    emits: ['updateShow'],

    computed: {
      ...mapState([
        'logged',
        'editor',
        'front',
        'translations',
        'usertype',
        'files',
      ]),
    },
    methods: {
      ...mapActions(['logout', 'changeToolSelected']),
      goFront() {
        window.location.href = this.front
      },
      show() {
        this.opened = !this.opened
        this.$emit('updateShow', this.opened)
      },
      generateMemory() {
        if (this.usertype == 2) {
          this.changeToolSelected(21)
        }
      },
      defineClass(key) {
        return this.$route.path.includes(key) ? 'router-link-exact-active' : ''
      },
    },
  }
</script>

<style scoped>
  .logo {
    height: 15px;
    vertical-align: middle;
  }
  .navbutton {
    background-color: initial;
    border-color: initial;
    border-width: 0;
    font-weight: bold;
  }
  .separator {
    border-bottom: 1px solid #ccc;
    margin: 20px 0;
  }
  .burger {
    background-color: initial;
    border-width: 0;
  }
  #allTheNav {
    text-align: -webkit-center;
  }
  .navbar {
    /* background-color: #3b5998; */
    overflow: hidden;
    height: 53px;
    padding-top: 0;
    /* justify-content: end; */
    /* align-items; */
    flex-wrap: wrap;
    display: flex;
    max-width: 1140px;
    z-index: 2;
  }

  .navbaropen {
    /* background-color: #3b5998; */
    overflow: hidden;
    height: 53px;
    margin-left: 250px;
  }

  .navbar a,
  .navbar .navbutton {
    float: left;
    display: block;
    /* color: #f2f2f2; */
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 17px;
  }

  .navbar ul {
    margin: 6px 0 0 0;
    list-style: none;
  }
  .navbar li {
    display: inline-block;
    vertical-align: middle;
  }
  .logout {
    padding-top: 6px;
  }
  .navbar a {
    color: black;
  }
  .navbar a:hover,
  .navbar .navbutton:hover {
    /* font-weight: bold; */
    color: #8a8a8a;
  }

  .navbar a:hover img {
    filter: invert(54%) sepia(0%) saturate(0%) hue-rotate(312deg)
      brightness(100%) contrast(99%);
  }

  .side-nav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #111;
    opacity: 0.9;
    overflow-x: hidden;
    padding-top: 60px;
    transition: 0.3s;
  }
  .navbar-nav {
    flex-direction: initial;
  }

  .sidenavopen {
    height: 100%;
    width: 250px;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #111;
    opacity: 0.9;
    overflow-x: hidden;
    padding-top: 60px;
    transition: 0.3s;
    text-align: right;
  }
  .side-nav button {
    background-color: initial;
    border-style: none;
    width: 100%;
    text-align: right;
  }

  .side-nav a,
  .side-nav button {
    padding: 10px 10px 10px 30px;
    text-decoration: none;
    font-size: 17px;
    color: #ccc;
    display: block;
    transition: 0.3s;
  }

  .side-nav a img {
    filter: invert(95%) sepia(2%) saturate(3%) hue-rotate(314deg)
      brightness(93%) contrast(78%);
  }
  .side-nav a:hover,
  .side-nav button:hover {
    color: #fff;
  }

  .side-nav .btn-close {
    position: absolute;
    top: 0;
    right: 22px;
    font-size: 36px;
    margin-left: 50px;
  }

  nav {
    transition: margin-left 0.3s;
  }

  .bar {
    display: block;
    height: 5px;
    width: 35px;
    background: #000;
    margin: 5px auto;
  }

  .midopen {
    width: 0;
  }
  .bar {
    transition: all 0.3s ease;
  }
  .topopen {
    transform: translateY(10px) rotateZ(45deg);
  }
  .botopen {
    transform: translateY(-10px) rotateZ(-45deg);
  }
  .sidenavopen a.router-link-exact-active {
    background-color: #8b8b8b;
    color: #fff;
  }
  .sidenavopen a.router-link-exact-active img,
  .side-nav a:hover img {
    filter: invert(100%) sepia(0%) saturate(2%) hue-rotate(354deg)
      brightness(105%) contrast(101%);
  }
  .navbar a.router-link-exact-active {
    text-decoration: underline;
    /* font-weight: bold; */
    color: #8a8a8a;
  }
  .navbar a.router-link-exact-active img {
    filter: invert(54%) sepia(0%) saturate(0%) hue-rotate(312deg)
      brightness(100%) contrast(99%);
    border-bottom: 1px solid;
  }
</style>
